export default __webpack_public_path__ + "static/media/IconDesc_PackagedNitrogen.256.16bab099.png";